import { ENTITY_CLASSNAMES } from '../base'

export const getEntity = (entity) => {
  if (!ENTITY_CLASSNAMES.includes(entity))
    throw new TypeError(
      `Unknown entity: '${entity}'. Known entities are: ${ENTITY_CLASSNAMES.toArray()}`
    )
  return (state) => state.entities.get(entity)
}
